import { useTranslation } from "react-i18next";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from "../../../functions/api";
import {
  TextField,
  Typography,
  Button,
  Box,
  Checkbox,
  Hidden,
  FormControlLabel,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableBody,
  Autocomplete,
  Divider,
  IconButton,
  LinearProgress,
  FormHelperText,
} from "@mui/material";
import axios from "axios";
import { API_BASE_URL } from "../../../constants/apiConstants";
import EuroSymbolIcon from "@mui/icons-material/EuroSymbol";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import ResponsiveDialog from "../../shared/components/ResponsiveDialog";
import { useSessionStorage } from "../../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../../constants/localStorage";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import LoadingCircle from "./LoadingCircle";
import { getFile } from "../getFile";
import { Visibility } from "@mui/icons-material";
import { useMessage } from "../../../context/message-context";
import openFile from "../../shared/functions/download";
import { blue } from "@mui/material/colors";
import FileUploadButton from "../../shared/components/PictureUploadComponent";
function EditAusgabe(props) {
  const { t } = useTranslation();
  //Standardfelder
  const theme = useTheme();
  const [eingabenModus, setEingabenModus] = useState(true);
  const [beleg, setBeleg] = useState({
    "7steuernBrutto": 0,
    "19steuernBrutto": 0,
    "0steuernBrutto": 0,
    "19%steuern": false,
    "7%steuern": false,
    "0%steuern": false,
    waehrung: "EURO",
  });

  const [fileUploaded, setFileUploaded] = useState(false);
  const [fileInfos, setFileInfos] = useState({});
  const [firstChecked, setFirstChecked] = useState("");
  const [errorFields, setErrorFields] = useState([]);
  const [errorTexts, setErrorTexts] = useState([]);
  const [belegLoadingState, setBelegLoadingState] = useState(0);
  const [belegAuslesenErfolgreich, setBelegAuslesenErfolgreich] = useState(false);
  const [parkedBeleg, setParkedBeleg] = useState([]);
  const [kommentarDaten, setKommentarDaten] = useState({});
  const [settingsKommentarDaten, setSettingsKommentarDaten] = useState({});

  const [chosenArtikel, setChosenArtikel] = useState({});
  const [isBelegLoading, setIsBelegLoading] = useState(false);
  const {
    open,
    onOpenChange,
    settings,
    lock,
    client,
    program,
    addBeleg,
    selectedBeleg,
    accessToken,
    artikelOptionen,
    openBeleg,
    currencies,
    kostenstellenOptionen,
  } = props;
  const { showErrorMessage } = useMessage();

  useEffect(() => {
    console.log(settings);

    setSettingsKommentarDaten({
      anzeigen: settings?.zusatzAngabeAnzeigen ?? false,
      pflicht: settings?.zusatzAngabepflicht ?? "",
      name: settings?.zusatzAngabeBez ?? false,
      auswahl: settings?.auswahl ?? [],
      freieEingabe: settings?.freieEingabe ?? false,
    });
  }, [settings]);

  useEffect(() => {
    if (selectedBeleg) {
      setBeleg({ ...selectedBeleg });

      const selectedArtikel = artikelOptionen?.find((artikel) => artikel.key === selectedBeleg?.ARTIKEL_KEY);

      setKommentarDaten({
        anzeigen: selectedArtikel?.kommentarfeld ?? false,
        pflicht: selectedArtikel?.kommentarpflicht ?? "",
        name: selectedArtikel?.kommentarfeldName ?? false,
        auswahl: selectedArtikel?.auswahl ?? [],
        freieEingabe: selectedArtikel?.freieEingabe ?? false,
      });
      setFileInfos({ fileName: selectedBeleg.fileName, fileNumber: selectedBeleg.fileNumber, fileKey: selectedBeleg.fileKey });
    } else {
      setBeleg({
        "7steuernBrutto": 0,
        "19steuernBrutto": 0,
        "0steuernBrutto": 0,
        "19%steuern": false,
        "7%steuern": false,
        "0%steuern": false,
        datum: "0000-00-00",
        waehrung: "EURO",
        KURS: "1",
        KREDITKARTE: false,
      });
      setFileInfos({});
    }
    setFirstChecked("");
    setErrorFields([]);
    setErrorTexts([]);
    setParkedBeleg([]);
    setFileUploaded(false);
  }, [open]);

  const changeFileInfos = (was, wert) => {
    const zwis = fileInfos;
    zwis[was] = wert;
    setFileInfos({ ...zwis });
  };

  function isFutureDate(dateString) {
    const date = new Date(dateString);
    const today = new Date();
    return date > today;
  }

  const changeValue = (was, wert) => {
    const zwis = beleg;
    if (parseFloat(wert) < 0) {
      return;
    }

    zwis[was] = wert;

    if (firstChecked === was && wert === false) {
      setFirstChecked("");
    }
    if (was==="eigenBeleg"){
        changeValue("19%steuern", false);
          changeValue("7%steuern", false);
          changeValue("0%steuern", true);
    }
    if (was === "ARTIKEL_KEY") {
      const selectedArtikel = artikelOptionen.find((e) => e.key === wert);
      setChosenArtikel(selectedArtikel);
      zwis["BETREFF"] = selectedArtikel?.bez;

      setKommentarDaten({
        anzeigen: selectedArtikel?.kommentarfeld ?? false,
        pflicht: selectedArtikel?.kommentarpflicht ?? "",
        name: selectedArtikel?.kommentarfeldName ?? false,
        auswahl: selectedArtikel?.auswahl ?? [],
        freieEingabe: selectedArtikel?.freieEingabe ?? false,
      });
      if (!artikelOptionen.find((e) => e.key === wert).kommentarfeld) {
        zwis["text"] = "";
        zwis["text_keys"] = [];
      }
      if (selectedArtikel?.festgelegterSteuersatz !== "") {
        if (selectedArtikel?.festgelegterSteuersatz == "19") {
          changeValue("19%steuern", true);
          changeValue("7%steuern", false);
          changeValue("0%steuern", false);
        }
        if (selectedArtikel?.festgelegterSteuersatz == "7") {
          changeValue("7%steuern", true);
          changeValue("19%steuern", false);
          changeValue("0%steuern", false);
        }
        if (selectedArtikel?.festgelegterSteuersatz == "0") {
          changeValue("0%steuern", true);
          changeValue("19%steuern", false);
          changeValue("7%steuern", false);
        }
      }
    }
    if (was === "waehrung" || was === "datum") {
      if (was === "waehrung" && wert === "EURO") {
        changeValue("KURS", 1);
      } else {
        if (zwis["waehrung"] !== "EURO") {
          getKurs(zwis["waehrung"], zwis["datum"]);
          changeValue("7%steuern", false);
          // changeValue("0%steuern", false);

          changeValue("19%steuern", false);
        }
      }
    }
    if (was === "text_keys") {
      let text = "";
      wert.forEach((object) => {
        text += object.label + "; ";
      });
      zwis["text"] = text;
      zwis["text_keys"] = wert;
    }
    if (was === "text") {
      zwis["text"] = wert;
    }
    if (was === "19%steuern") {
      if (wert === false) {
        zwis["19steuern"] = 0.0; // Ensure two decimal places
        zwis["19steuernBrutto"] = 0;
        if (firstChecked === "19steuernBrutto") {
          if (zwis["7%steuern"]) {
            setFirstChecked("7steuernBrutto");
          } else if (zwis["0%steuern"]) {
            setFirstChecked("0steuernBrutto");
          } else {
            setFirstChecked("");
          }
        }
      } else {
        if (!zwis["7%steuern"] && !zwis["0%steuern"]) {
          zwis["19steuernBrutto"] = zwis["gesamtBrutto"];
          zwis["19steuern"] = Math.round(parseFloat(parseFloat(zwis["gesamtBrutto"] || 0) / 119) * 19 * 100) / 100;
          zwis["19steuernNetto"] = Math.round(parseFloat(zwis["gesamtBrutto"] || "0") - parseFloat(zwis["19steuern"]));
          setFirstChecked("19steuernBrutto");
        }
      }
    }
    if (was === "0%steuern") {
      if (wert === false) {
        zwis["0steuernBrutto"] = 0;
        if (firstChecked === "0steuernBrutto") {
          if (zwis["19%steuern"]) {
            setFirstChecked("19steuernBrutto");
          } else if (zwis["7%steuern"]) {
            setFirstChecked("7steuernBrutto");
          } else {
            setFirstChecked("");
          }
        }

        if (firstChecked === "0steuernBrutto") {
          setFirstChecked("");
        }
      } else if (!zwis["7%steuern"] && !zwis["19%steuern"]) {
        zwis["0steuernBrutto"] = zwis["gesamtBrutto"];
        zwis["0steuern"] = 0.0;
        zwis["19steuernNetto"] = Math.round(parseFloat(zwis["gesamtBrutto"] || "0") - parseFloat(zwis["19steuern"]));
        setFirstChecked("0steuernBrutto");
      }
    }
    if (was === "19steuernBrutto") {
      if (firstChecked !== "19steuernBrutto") {
        if (firstChecked === "7steuernBrutto") {
          changeValue(firstChecked, parseFloat(zwis["gesamtBrutto"]) - parseFloat(parseFloat(wert || "0")) - parseFloat(zwis["0steuernBrutto"] || "0"));
        } else {
          changeValue(firstChecked, parseFloat(zwis["gesamtBrutto"]) - parseFloat(parseFloat(wert || "0")) - parseFloat(zwis["7steuernBrutto"] || "0"));
        }
      }
      zwis["19steuern"] = Math.round((parseFloat(wert || "0") / 119) * 19 * 100) / 100;
      zwis["19steuernNetto"] = Math.round(parseFloat(wert - zwis["19steuern"]) * 100) / 100;
    }
    if (was === "0steuernBrutto") {
      if (firstChecked !== "0steuernBrutto") {
        if (firstChecked === "7steuernBrutto") {
          changeValue(firstChecked, parseFloat(zwis["gesamtBrutto"]) - parseFloat(parseFloat(wert || "0")) - parseFloat(zwis["19steuernBrutto"] || "0"));
        } else {
          changeValue(firstChecked, parseFloat(zwis["gesamtBrutto"]) - parseFloat(parseFloat(wert || "0")) - parseFloat(zwis["7steuernBrutto"] || "0"));
        }
      }
      zwis["0steuern"] = 0;
      zwis["0steuernNetto"] = wert;
    }
    if (was === "7steuernBrutto") {
      if (firstChecked !== "7steuernBrutto") {
        if (firstChecked === "0steuernBrutto") {
          changeValue(firstChecked, parseFloat(zwis["gesamtBrutto"]) - parseFloat(parseFloat(wert || "0")) - parseFloat(zwis["19steuernBrutto"] || "0"));
        } else {
          changeValue(firstChecked, parseFloat(zwis["gesamtBrutto"]) - parseFloat(parseFloat(wert || "0")) - parseFloat(zwis["0steuernBrutto"] || "0"));
        }
      }
      zwis["7steuern"] = Math.round((parseFloat(wert || "0") / 107) * 7 * 100) / 100;
      zwis["7steuernNetto"] = Math.round(parseFloat(wert - zwis["7steuern"]) * 100) / 100;
    }
    if (was === "19steuern") {
      zwis["19steuernNetto"] = Math.round((parseFloat(wert || "0") / 19) * 100 * 100) / 100;
      zwis["19steuernBrutto"] = Math.round(((parseFloat(wert || "0") / 19) * 100 + wert) * 100) / 100;
    }
    if (was === "7steuern") {
      zwis["7steuernNetto"] = Math.round((parseFloat(wert || "0") / 7) * 100) / 100;
    }
    if (was === "7%steuern") {
      if (wert === false) {
        zwis["7steuern"] = 0.0;
        zwis["7steuernBrutto"] = 0.0;
        zwis["7steuernNetto"] = 0.0;
        if (firstChecked === "7steuernBrutto") {
          if (zwis["19%steuern"]) {
            setFirstChecked("19steuernBrutto");
          } else if (zwis["0%steuern"]) {
            setFirstChecked("0steuernBrutto");
          } else {
            setFirstChecked("");
          }
        }
      } else if (!zwis["19%steuern"] && !zwis["0%steuern"]) {
        zwis["7steuern"] = Math.round(parseFloat(parseFloat(zwis["gesamtBrutto"] || 0) / 107) * 7 * 100) / 100;
        zwis["7steuernBrutto"] = zwis["gesamtBrutto"];
        setFirstChecked("7steuernBrutto");
      } else {
      }
    }
    if (was === "gesamtBrutto" || was === "KURS") {
      if (zwis["19%steuern"] && !zwis["7%steuern"] && !zwis["0%steuern"]) {
        zwis["19steuern"] = Math.round(parseFloat((parseFloat(zwis["gesamtBrutto"]) || 0) / parseFloat(zwis["KURS"]) / 119) * 19 * 100) / 100;
        zwis["19steuernBrutto"] = wert;
      } else if (zwis["7%steuern"] && !zwis["19%steuern"] && !zwis["0%steuern"]) {
        zwis["7steuern"] = Math.round(parseFloat(parseFloat(zwis["gesamtBrutto"] || 0) / parseFloat(zwis["KURS"]) / 107) * 7 * 100) / 100;
        zwis["7steuernBrutto"] = wert;
      } else if (zwis["0%steuern"] && !zwis["7%steuern"] && !zwis["19%steuern"]) {
        zwis["0steuern"] = 0.0;
        zwis["0steuernBrutto"] = wert;
      }
    }

    zwis["nettoGesamt"] =
      Math.round(
        (parseFloat(zwis["gesamtBrutto"] / parseFloat(zwis["KURS"])) - parseFloat(zwis["7steuern"] || "0") - parseFloat(zwis["19steuern"] || "0")) * 100,
      ) / 100;
    zwis["AUSZAHLUNG"] = Math.round(parseFloat(zwis["gesamtBrutto"] / parseFloat(zwis["KURS"])) * 100) / 100;
    if (zwis["KREDITKARTE"]) {
      zwis["AUSZAHLUNG"] = 0;
    }
    setBeleg({ ...zwis });
    if (was === "7%steuern" && wert === false) {
      if (zwis["19%steuern"]) {
        changeValue("19%steuern", true);
      }
      if (zwis["0%steuern"]) {
        changeValue("0%steuern", true);
      }
    }
    if (was === "19%steuern" && wert === false) {
      if (zwis["7%steuern"]) {
        changeValue("7%steuern", true);
      }
      if (zwis["0%steuern"]) {
        changeValue("0%steuern", true);
      }
    }
    if (was === "0%steuern" && wert === false) {
      if (zwis["19%steuern"]) {
        changeValue("19%steuern", true);
      }
      if (zwis["7%steuern"]) {
        changeValue("7%steuern", true);
      }
    }
  };

  const getKurs = (waehrung, datum) => {
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: program,
      statement: "BELEGERKENNUNG_GET_KURS",
      waehrung: waehrung,
      datum: datum,
    };
    apiRequest("POST", "daten", payload, headers, getKursCb, setRedirect);
  };

  const getKursCb = (response) => {
    changeValue("KURS", response.data.kurs);
    changeValue("0%steuern", true);
  };

  const changeBruttoSteuern = (was, wert) => {
    const zwis = beleg;
    zwis[was] = wert;
  };
  const controller = useRef(new AbortController());

  function uploadFile(event, tmpkey, kz) {
    // Erlaubte Dateitypen. Lassen wir schon beim input nicht anderst zu aber besser das hier gleich mit Meldung erneut zu prüfen
    const extensions = [".PDF", ".pdf", ".png", ".jpg", ".jfif", ".jpeg", ".pjpeg", ".pjp"];
    const fileName = event.target.files[0]?.name;
    const isMatch = extensions.some((ext) => fileName.endsWith(ext));

    if (!isMatch) {
      showErrorMessage("Ungültiger Dateityp");
      return;
    }

    setFileUploaded(true);
    // changeValue("fileName", event.target.files[0]?.name);
    const payload = {
      program: program,
      statement: "UPLOAD_FILE",
      mandant: client,
      fileName: event.target.files[0]?.name,
    };
    const formData = new FormData();
    formData.append("payload", JSON.stringify(payload));
    formData.append("file", event.target.files[0]);
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiDataRequest(formData, headers).then(uploadCb).catch(console.log);

    return () => {
      controller.current.abort();
    };
  }
  const apiDataRequest = (payload, headers) => {
    return axios.post(API_BASE_URL + "daten", payload, {
      withCredentials: true,
      headers: headers,
      signal: controller.current.signal,
    });
  };
  const analyseFile = (fileNumber) => {
    setIsBelegLoading(true);
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: program,
      statement: "OCR_3",
      fileNumber: fileNumber,
    };
    apiRequest("POST", "daten", payload, headers, analyseFileCb, setRedirect);
  };
  const analyseFileCb = (response) => {
    setBelegLoadingState(100);
    setIsBelegLoading(false);
    setBelegAuslesenErfolgreich(response.data.ohneFehler === "True" || response.data.ohneFehler === true);
    setParkedBeleg({ ...response.data.WERTE, fileNumber: response.data.fileNumber });
  };
  const editFileErgebnis = (fileNumber) => {
    setIsBelegLoading(true);
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: program,
      statement: "OCR_4",
      fileNumber: fileNumber,
    };
    apiRequest("POST", "daten", payload, headers, editFileCb, setRedirect);
  };
  const editFileCb = (response) => {
    setBelegLoadingState(100);
    setIsBelegLoading(false);
    setBelegAuslesenErfolgreich(response.data.ohneFehler === "True" || response.data.ohneFehler === true);
    setParkedBeleg({ ...response.data.WERTE, fileNumber: response.data.fileNumber });
  };
  const readFile = (fileNumber) => {
    setIsBelegLoading(true);
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    const payload = {
      mandant: client,
      program: program,
      statement: "OCR_2",
      fileNumber: fileNumber,
    };
    apiRequest("POST", "daten", payload, headers, readFileCb, setRedirect);
  };
  const readFileCb = (response) => {
    setBelegLoadingState(50);
    analyseFile(fileInfos.fileNumber);
  };
  const setRedirect = (path) => {
    // navigate(path);
  };

  const uploadCb = (response) => {
    setBelegLoadingState(33);
    changeFileInfos("fileName", response.data.fileName);
    changeFileInfos("fileNumber", response.data.fileNumber);
    changeFileInfos("fileKey", undefined);

    readFile(response.data.fileNumber);
  };
  const savebeleg = () => {
    const { errors, texte } = checkErrors();

    setErrorFields(errors);
    setErrorTexts(texte);
    if (errors.length > 0) {
      return;
    }
    addBeleg({ ...beleg, fileNumber: fileInfos.fileNumber, fileName: fileInfos.fileName, fileKey: fileInfos.fileKey });
  };

  function isValidDate(date) {
    return !isNaN(Date.parse(date));
  }
  const isRealNumber = (number) => {
    if (isNaN(parseFloat(number))) {
      return false;
    }
    if (parseFloat(number) === 0) {
      return false;
    }
    return true;
  };
  const checkErrors = () => {
    var errors = [];
    var texte = {};
    // existing check
    if (artikelOptionen && !beleg?.["ARTIKEL_KEY"]) {
      errors.push("BETREFF");
      texte["BETREFF"] = "Bitte geben Sie einen Betreff an";
    }
    if (parseFloat(beleg?.["7steuernBrutto"]) > parseFloat(beleg?.["gesamtBrutto"])) {
      errors.push("7steuernBrutto");
      texte["7steuernBrutto"] = "Betrag ist größer als der Gesamtbetrag";
    }
    if (kommentarDaten?.pflicht && !beleg?.["text"]) {
      errors.push("text");
      texte["text"] = "Bitte füllen Sie dieses Feld aus, da es für den ausgewählten Artikel erforderlich ist.";
    }
    if (settingsKommentarDaten?.pflicht && !beleg?.["text"]) {
      errors.push("text");
      texte["text"] = "Bitte füllen Sie dieses Feld aus, da es für den ausgewählten Artikel erforderlich ist.";
    }
    // additional checks
    if (parseFloat(beleg?.["19steuernBrutto"]) > parseFloat(beleg?.["gesamtBrutto"])) {
      errors.push("19steuernBrutto");
      texte["19steuernBrutto"] = "Betrag ist größer als der Gesamtbetrag";
    }
    if (parseFloat(beleg?.["0steuernBrutto"]) > parseFloat(beleg?.["gesamtBrutto"])) {
      errors.push("0steuernBrutto");
      texte["0steuernBrutto"] = "Betrag ist größer als der Gesamtbetrag";
    }
    if (beleg?.["datum"] === undefined || beleg?.["datum"] === null) {
      errors.push("datum");
      texte["datum"] = "Datum ist erforderlich";
    } else if (isFutureDate(beleg?.["datum"])) {
      errors.push("datum");
      texte["datum"] = "Datum kann nicht in der Zukunft liegen!";
    }

    if (parseFloat(beleg?.["gesamtNetto"]) > parseFloat(beleg?.["gesamtBrutto"])) {
      errors.push("gesamtNetto");
      texte["gesamtNetto"] = "Nettobetrag ist größer als der Bruttobetrag";
    }
    if (beleg?.["7steuernBrutto"] < 0 || beleg?.["19steuernBrutto"] < 0 || beleg?.["0steuernBrutto"] < 0) {
      errors.push("Steuern");
      texte["Steuern"] = "Steuern können nicht negativ sein";
    }
    if (parseFloat(beleg?.["gesamtBrutto"] || "0") === 0) {
      errors.push("gesamtBrutto");
      texte["gesamtBrutto"] = "Gesamtbetrag kann nicht 0 sein";
    }

    if (beleg?.["gesamtBrutto"] < 0) {
      errors.push("gesamtBrutto");
      texte["gesamtBrutto"] = "Gesamtbetrag kann nicht negativ sein";
    }

    if (beleg?.["gesamtNetto"] < 0) {
      errors.push("gesamtNetto");
      texte["gesamtNetto"] = "Nettobetrag kann nicht negativ sein";
    }

    if (beleg?.["datum"] !== undefined && beleg?.["datum"] !== null && !isValidDate(beleg?.["datum"])) {
      errors.push("datum");
      texte["datum"] = "Datum ist ungültig";
    }
    const today = new Date();
    const date = new Date(beleg?.["datum"]);
    const diffInMonths = (today.getFullYear() - date.getFullYear()) * 12 + today.getMonth() - date.getMonth();
    if (diffInMonths > 12) {
      errors.push("datum");
      texte["datum"] = "Datum ist länger als 12 Monate in der Vergangenheit";
    }

    const totalSteuern = parseFloat(beleg?.["7steuernBrutto"]) + parseFloat(beleg?.["19steuernBrutto"]) + parseFloat(beleg?.["0steuernBrutto"]);
    if (totalSteuern > parseFloat(beleg?.["gesamtBrutto"])) {
      texte["7steuernBrutto"] = "Die Summe der Steuerbeträge ist größer als der Gesamtbetrag";
      texte["19steuernBrutto"] = "Die Summe der Steuerbeträge ist größer als der Gesamtbetrag";
      texte["0steuernBrutto"] = "Die Summe der Steuerbeträge ist größer als der Gesamtbetrag";
    }
    if (parseFloat(beleg?.["gesamtBrutto"]) > 0) {
      const steuerBrutto7 = parseFloat(beleg?.["7steuernBrutto"] || 0);
      const steuerBrutto19 = parseFloat(beleg?.["19steuernBrutto"] || 0);
      const steuerBrutto0 = parseFloat(beleg?.["0steuernBrutto"] || 0);
      const gesamtSteuerBrutto = (parseFloat(steuerBrutto7) + parseFloat(steuerBrutto19) + parseFloat(steuerBrutto0)).toFixed(2);
      if (parseFloat(gesamtSteuerBrutto) !== parseFloat(beleg?.["gesamtBrutto"])) {
        errors.push("steuernAllgemein");
        texte["steuernAllgemein"] = "Die einzelnen Steuerbrutto Werte sind nicht gleich dem Gesamt Brutto";
      }
      // const brutto19=parseFloat((parseFloat(beleg?.["19steuernBrutto"])/19)*100).toFixed(2)
    }
    if (!beleg["7%steuern"] && !beleg["19%steuern"] && !beleg["0%steuern"]) {
      errors.push("steuernAllgemein");
      texte["steuernAllgemein"] = "Bitte einen Steuersatz wählen";
    }
    // const brutto19=parseFloat((parseFloat(beleg?.["19steuernBrutto"])/19)*100).toFixed(2)

    return { errors: errors, texte: texte };
  };

  const werteUebernehmen = () => {
    if (parseFloat(beleg["bruttoGesamt"] || "0") !== 0) {
      if (beleg["datum"] === "" || beleg["datum"] === undefined) {
        changeValue("datum", parkedBeleg["datum"]);
      }
      return;
    }
    if (parkedBeleg["datum"] !== "" && parkedBeleg["datum"] !== undefined && parkedBeleg["datum"] !== "0000-00-00") {
      changeValue("datum", parkedBeleg["datum"]);
    }
    if (parseFloat(parkedBeleg?.["19steuern"] || "0") !== 0) {
      changeValue("19%steuern", true);
    }
    if (parseFloat(parkedBeleg?.["7steuern"] || "0") !== 0) {
      changeValue("7%steuern", true);
    }
    if (parseFloat(parkedBeleg?.["0steuern"] || "0") !== 0) {
      changeValue("0%steuern", true);
    }
    Object.keys(parkedBeleg)?.forEach((key) => {
      if (beleg[key] === "" || beleg[key] === undefined) {
        changeValue(key, parkedBeleg[key]);
      }
    });
    // setBeleg(parkedBeleg);
    setParkedBeleg([]);
  };

  const renderKommentarFeld = () => {
    const aktiveKommentarDaten = kommentarDaten?.anzeigen ? kommentarDaten : settingsKommentarDaten?.anzeigen ? settingsKommentarDaten : null;
    return (
      <>
        {aktiveKommentarDaten &&
          (aktiveKommentarDaten?.auswahl?.length === 0 ? (
            <Grid item xs={12}>
              <TextField
                variant="standard"
                size="small"
                fullWidth
                disabled={lock}
                label={aktiveKommentarDaten?.name + (aktiveKommentarDaten?.pflicht ? "*" : "")}
                error={errorFields.includes("text")}
                helperText={errorFields.includes("text") ? errorTexts["text"] : ""}
                onChange={(e) => changeValue("text", e.target.value)}
                value={beleg?.["text"] || ""}
              />
            </Grid>
          ) : (
            <Grid item xs={12}>
              {aktiveKommentarDaten?.freieEingabe ? (
                <Autocomplete
                  multiple
                  fullWidth
                  value={beleg?.["text"] ? beleg?.["text"].split(";") : []}
                  filterOptions={(options, params) => {
                    if (options[0] === undefined) {
                      return params.inputValue !== "" ? [{ value: params.inputValue, label: `"${params.inputValue}" hinzufügen` }] : [];
                    }
                    const optionen = options?.filter((e) => e.label.toUpperCase().includes(params.inputValue.toUpperCase()));
                    if (params.inputValue !== "") {
                      optionen.push({ value: params.inputValue, label: `"${params.inputValue}" hinzufügen` });
                    }
                    return optionen;
                  }}
                  onChange={(event, newValue) => {
                    const labels = newValue.map((value) => {
                      if (typeof value === "string") return value;
                      return value.label.includes("hinzufügen") ? value.value : value.label;
                    });
                    changeValue("text", labels.join(";"));
                  }}
                  options={aktiveKommentarDaten?.auswahl}
                  variant="outlined"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      error={errorFields.includes("text")}
                      helperText={errorFields.includes("text") ? errorTexts["text"] : ""}
                      label={aktiveKommentarDaten?.name + (aktiveKommentarDaten?.pflicht ? "*" : "")}
                    />
                  )}
                />
              ) : (
                <Autocomplete
                  multiple
                  fullWidth
                  value={beleg?.["text_keys"] || []}
                  onChange={(event, newValue) => changeValue("text_keys", newValue)}
                  options={aktiveKommentarDaten?.auswahl}
                  variant="outlined"
                  disabled={lock}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      error={errorFields.includes("text")}
                      helperText={errorFields.includes("text") ? errorTexts["text"] : ""}
                      label={aktiveKommentarDaten?.name + (aktiveKommentarDaten?.pflicht ? "*" : "")}
                    />
                  )}
                  getOptionLabel={(option) => (typeof option === "string" ? option : option.label)}
                />
              )}
            </Grid>
          ))}
      </>
    );
  };
  return (
    <>
      <ResponsiveDialog
        title={t("Beleg")}
        maxWidth="sm"
        open={open}
        setOpen={onOpenChange}
        actionButton={
          <>
            <Button
              color="primary"
              variant="contained"
              onClick={() => savebeleg()}
              disabled={(fileUploaded && (fileInfos.fileName === "" || fileInfos.fileName === undefined)) || lock}
            >
              {t("Speichern")}
            </Button>
            <Button color="primary" onClick={() => onOpenChange()}>
              {t("Zurück")}
            </Button>
          </>
        }
      >
        <Box p={2}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FileUploadButton
                label={t("Datei auswählen")}
                multiple={false}
                // enableCamera={true}
                accept="application/pdf,image/png,image/jpeg,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                onChange={uploadFile}
              />
              {/* <input multiple color="primary" type="file" id="file-upload" disabled={lock} onChange={(e) => uploadFile(e)} style={{ display: "none" }} />
              <label htmlFor="file-upload" className="mr-2">
                <Button fullWidth disabled={lock} style={{ marginTop: "5px" }} variant="contained" component="span" color="primary" label={t("Dateiupload")}>
                  {t("Beleg hochladen")}
                </Button> */}
              {/* <Typography variant="caption">{t("Sie können die Belegdaten auch vor Abschluss des auslesen manuell eingeben")}</Typography> */}
              {/* </label> */}
            </Grid>
            <Grid item xs={12} justifyContent={"center"}>
              {parkedBeleg.fileNumber || isBelegLoading ? (
                // <LinearProgress  value={belegLoadingState} isLoading={isBelegLoading}/>
                <div style={{ paddingBottom: "30px", paddingTop: "200" }}>
                  <LoadingCircle value={belegLoadingState} success={belegAuslesenErfolgreich} onClick={werteUebernehmen} isLoading={isBelegLoading} />
                </div>
              ) : (
                <Box sx={{ height: 25 }}></Box>
              )}
              {fileInfos.fileName && (
                <>
                  {fileInfos.fileName}
                  <IconButton onClick={() => openBeleg(fileInfos)}>
                    <Visibility />
                  </IconButton>
                </>
              )}
            </Grid>
            {eingabenModus && (
              <>
                <Grid item xs={6}>
                  {artikelOptionen ? (
                    <TextField
                      variant="standard"
                      size="small"
                      fullWidth
                      label="Artikel *"
                      select
                      disabled={lock}
                      error={errorFields.includes("BETREFF")}
                      helperText={errorFields.includes("BETREFF") ? errorTexts["BETREFF"] : ""}
                      onChange={(e) => changeValue("ARTIKEL_KEY", e.target.value)}
                      value={beleg?.["ARTIKEL_KEY"] ? beleg?.["ARTIKEL_KEY"] : ""}
                    >
                      {artikelOptionen?.map((artikel) => {
                        return (
                          <MenuItem key={artikel.key} value={artikel.key} index={artikel.key}>
                            {artikel.bez}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  ) : (
                    <>
                      {settings?.betreffVorgaben !== "" && settings?.betreffVorgaben !== undefined ? (
                        <TextField
                          variant="standard"
                          size="small"
                          fullWidth
                          label="Betreff"
                          select
                          onChange={(e) => changeValue("BETREFF", e.target.value)}
                          value={beleg?.["BETREFF"] ? beleg?.["BETREFF"] : ""}
                        >
                          {settings?.betreffVorgaben?.split("\n").map((item2, index2) => {
                            var tmpkey = "";
                            var tmpval = "";
                            var tmppos = item2.indexOf(";");
                            if (tmppos >= 0) {
                              tmpkey = item2.substr(0, tmppos);
                              tmpval = item2.substr(tmppos + 1);
                            } else {
                              tmpkey = item2;
                              tmpval = item2;
                            }
                            return (
                              <MenuItem key={tmpval} value={tmpval} index={index2}>
                                {tmpval}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      ) : (
                        <TextField
                          variant="standard"
                          size="small"
                          fullWidth
                          disabled={lock}
                          label="Betreff"
                          onChange={(e) => changeValue("BETREFF", e.target.value)}
                          value={beleg?.["BETREFF"] ? beleg?.["BETREFF"] : ""}
                        />
                      )}
                    </>
                  )}
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    variant="standard"
                    size="small"
                    fullWidth
                    disabled={lock}
                    label="Datum *"
                    type="date"
                    error={errorFields.includes("datum")}
                    helperText={errorFields.includes("datum") ? errorTexts["datum"] : ""}
                    onChange={(e) => changeValue("datum", e.target.value)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={beleg?.["datum"] ? beleg?.["datum"] : ""}
                  />
                </Grid>
                <Grid item xs={!settings?.kreditkarte_sperren ? 6 : 12}>
                  <TextField
                    variant="standard"
                    size="small"
                    fullWidth
                    type="number"
                    disabled={lock}
                    label="Gesamt (Brutto)"
                    error={errorFields.includes("gesamtBrutto")}
                    helperText={errorFields.includes("gesamtBrutto") ? errorTexts["gesamtBrutto"] : ""}
                    onChange={(e) => changeValue("gesamtBrutto", e.target.value)}
                    value={beleg?.["gesamtBrutto"] ? parseFloat(beleg?.["gesamtBrutto"]) : ""}
                  />
                </Grid>
                {!settings?.kreditkarte_sperren && (
                  <Grid item xs={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={beleg?.["KREDITKARTE"]}
                          disabled={lock}
                          onChange={(e) => changeValue("KREDITKARTE", e.target.checked)}
                          color="primary"
                        />
                      }
                      label={<Typography>Firmenkreditkarte / Firmenkasse verwendet</Typography>}
                    />
                  </Grid>
                )}
                {renderKommentarFeld()}

                {settings?.waehrungen && (
                  <Grid item xs={12}>
                    <FormControl variant="standard" sx={{ minWidth: 120 }} fullWidth>
                      <InputLabel id="">Bezahlt in</InputLabel>
                      <Select
                        disabled={lock || beleg["datum"] === "0000-00-00"}
                        variant="standard"
                        fullWidth
                        label="Bezahlt"
                        helperText=""
                        value={beleg?.["waehrung"]}
                        onChange={(e) => changeValue("waehrung", e.target.value)}
                      >
                        {currencies.map((waehrung) => (
                          <MenuItem value={waehrung.value}>{waehrung.label}</MenuItem>
                        ))}
                        <MenuItem value={"EURO"}>Euro </MenuItem>
                      </Select>
                      <FormHelperText>Währung kann erst nach der Datumseingabe ausgewählt werden</FormHelperText>
                    </FormControl>
                  </Grid>
                )}                
                {settings?.eigenBeleg ? (
                  <>
                    <Grid item xs={12}>
                      <Typography>Steuersatz</Typography>
                      {errorFields?.includes("steuernAllgemein") && <Typography color="error">{errorTexts["steuernAllgemein"]}</Typography>}
                    </Grid>
                    <Grid item xs={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={beleg?.["eigenBeleg"] === true}
                            // disabled={beleg["waehrung"] !== "EURO" || lock || (chosenArtikel?.festgelegterSteuersatz !== "" && artikelOptionen)}
                            onChange={(e) => changeValue("eigenBeleg", e.target.checked)}
                            color="primary"
                          />
                        }
                        label={<Typography color={firstChecked === "19steuernBrutto" ? "primary" : ""}>Eigenbeleg</Typography>}
                      />
                    </Grid>
                    <Grid item xs={8}></Grid>
                  </>
                ) : (
                  <Grid item xs={12}>
                    <Typography>Steuersatz</Typography>
                    {errorFields?.includes("steuernAllgemein") && <Typography color="error">{errorTexts["steuernAllgemein"]}</Typography>}
                  </Grid>
                )}
                <Grid item xs={4}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={beleg?.["19%steuern"] === true}
                        disabled={
                          beleg["waehrung"] !== "EURO" ||
                          lock ||
                          (chosenArtikel?.festgelegterSteuersatz !== "" && artikelOptionen) ||
                          beleg?.["eigenBeleg"] === true
                        }
                        onChange={(e) => changeValue("19%steuern", e.target.checked)}
                        color="primary"
                      />
                    }
                    label={<Typography color={firstChecked === "19steuernBrutto" ? "primary" : ""}>19 % Steuern</Typography>}
                  />
                  {beleg?.["19%steuern"] && (beleg?.["7%steuern"] || beleg?.["0%steuern"]) && (
                    <TextField
                      variant="standard"
                      size="small"
                      fullWidth
                      disabled={lock}
                      label="19% (Brutto Betrag)"
                      type="number"
                      error={errorFields.includes("19steuern")}
                      helperText={
                        errorFields.includes("19steuern")
                          ? errorTexts["19steuern"]
                          : "Netto:" + (beleg?.["19steuernNetto"] || "0") + " /Steuern:" + (beleg?.["19steuern"] || "0")
                      }
                      onChange={(e) => changeValue("19steuernBrutto", e.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={beleg?.["19steuernBrutto"] ? beleg?.["19steuernBrutto"] : ""}
                    />
                  )}
                </Grid>
                <Grid item xs={4}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={beleg?.["7%steuern"] === true}
                        disabled={
                          beleg["waehrung"] !== "EURO" ||
                          lock ||
                          (chosenArtikel?.festgelegterSteuersatz !== "" && artikelOptionen) ||
                          beleg?.["eigenBeleg"] === true
                        }
                        onChange={(e) => changeValue("7%steuern", e.target.checked)}
                        color="primary"
                      />
                    }
                    label={<Typography color={firstChecked === "7steuernBrutto" ? "primary" : ""}>7 % Steuern</Typography>}
                  />
                  {beleg?.["7%steuern"] && (beleg?.["19%steuern"] || beleg?.["0%steuern"]) && (
                    <TextField
                      variant="standard"
                      size="small"
                      fullWidth
                      disabled={lock}
                      label="7% (Brutto Betrag)"
                      error={errorFields.includes("7steuern")}
                      helperText={
                        errorFields.includes("7steuernBrutto")
                          ? errorTexts["7steuern7steuernBrutto"]
                          : "Netto:" + (beleg?.["7steuernNetto"] || "0") + " /Steuern:" + (beleg?.["7steuern"] || "0")
                      }
                      type="number"
                      onChange={(e) => changeValue("7steuernBrutto", e.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={beleg?.["7steuernBrutto"] ? beleg?.["7steuernBrutto"] : ""}
                    />
                  )}
                </Grid>
                <Grid item xs={4}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={beleg?.["0%steuern"]}
                        disabled={beleg["waehrung"] !== "EURO" || lock || (chosenArtikel?.festgelegterSteuersatz !== "" && artikelOptionen)}
                        onChange={(e) => changeValue("0%steuern", e.target.checked)}
                        color="primary"
                      />
                    }
                    label={<Typography color={firstChecked === "0steuernBrutto" ? "primary" : ""}>0 % Steuern</Typography>}
                  />

                  {beleg?.["0%steuern"] && (beleg?.["19%steuern"] || beleg?.["7%steuern"]) && (
                    <TextField
                      variant="standard"
                      size="small"
                      fullWidth
                      disabled={lock}
                      label="0% (Brutto Betrag)"
                      type="number"
                      error={errorFields.includes("0steuernBrutto")}
                      helperText={
                        errorFields.includes("0steuernBrutto")
                          ? errorTexts["0steuern"]
                          : "Netto:" + (beleg?.["0steuernNetto"] || "0") + " /Steuern:" + (beleg?.["0steuern"] || "0")
                      }
                      onChange={(e) => changeValue("0steuernBrutto", e.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={beleg?.["0steuernBrutto"] ? beleg?.["0steuernBrutto"] : ""}
                    />
                  )}
                </Grid>
              </>
            )}
          </Grid>
          {settings?.aufKostenstellenTeilen && (
            <Grid item xs={12} sx={{ mt: 1 }}>
              <Autocomplete
                multiple
                id="kostenstellenSelection"
                disabled={lock}
                value={beleg?.["kostenstellenAuswahl"] ? beleg?.["kostenstellenAuswahl"] : []}
                onChange={(event, newValue) => {
                  changeValue("kostenstellenAuswahl", newValue);
                }}
                options={kostenstellenOptionen}
                getOptionLabel={(option) => option.bez}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Kostenstellen(n) auswählen"
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                    }}
                  />
                )}
              />
            </Grid>
          )}
        </Box>
        <Grid container borderTop={2} sx={{ p: 2, mt: 1 }} borderColor={theme.palette.primary} alignItems="center" justifyContent="center">
          <Grid item xs={12}>
            <Typography variant="h5">Zusammenfassung</Typography>
          </Grid>
          <Grid item xs={9}>
            <Typography fontWeight={600}>Netto Betrag</Typography>
          </Grid>
          <Grid item xs={3}></Grid>
          <Grid item xs={9}></Grid>
          <Grid item xs={3}>
            <Typography align="center">{beleg?.["nettoGesamt"]}</Typography>
          </Grid>
          <Grid item xs={12} full border={"1px solid #ccc"}></Grid>
          <Grid item xs={9}>
            <Typography fontWeight={600}>Steuern</Typography>
          </Grid>
          <Grid item xs={3}></Grid>
          <Grid item xs={9}>
            {"19%"}
          </Grid>
          <Grid item xs={3}>
            <Typography align="center">{beleg?.["19steuern"]}</Typography>
          </Grid>
          <Grid item xs={12} full border={"1px solid #ccc"}></Grid>
          <Grid item xs={9}>
            7%
          </Grid>
          <Grid item xs={3}>
            <Typography align="center">{beleg?.["7steuern"]}</Typography>
          </Grid>{" "}
          {/* <Grid item xs={12} full border={"1px solid #ccc"}></Grid>         */}
          <Grid item xs={12} full border={"1px dotted"}></Grid>
          <Grid item xs={3}>
            Gesamt
          </Grid>{" "}
          <Grid item xs={5}></Grid>
          <Grid item xs={4}>
            <Typography fontWeight={600} variant="h4" sx={{ p2: 1 }}>
              {beleg?.AUSZAHLUNG}
              <EuroSymbolIcon sx={{ pt: 2 }} fontSize="large" />
            </Typography>
          </Grid>{" "}
          <Grid item xs={0}></Grid>
        </Grid>
      </ResponsiveDialog>
    </>
  );
}

export default EditAusgabe;
